module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/user/feed') ? _c('div', [(_vm.privileges.chat.private_chat) ? _c('v-btn', {
    staticClass: "chatbutton primary",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "chaticon"
  }, [_vm._v("chat")]), _vm._v(" "), (_vm.unread) ? _c('span', {
    staticClass: "unread"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa7f8d18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/sideboxChat.vue
// module id = 834
// module chunks = 3 4 8 13 14 16 17 18 19 20 25 26 31 32